export default function errorHandler() {
  console.error.apply(console, arguments);
}
